// extracted by mini-css-extract-plugin
module.exports = {"content":"MyReports-module__content___2LKR0","empty":"MyReports-module__empty___2Usqv"};